import React from "react";
import { profile, navLinks } from "../mock";

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="bg-[#2E2621] text-[#E7D8C6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="text-center border-b border-[#4A3E36] pb-12">
          <p className="font-serif-display italic text-2xl md:text-4xl text-[#FAF5EF] max-w-2xl mx-auto leading-snug">
            « {profile.tagline} »
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-10">
          <div className="text-center md:text-left">
            <div className="font-script text-3xl text-[#C88A63]">{profile.brand}</div>
            <div className="font-body text-xs tracking-wide-2 uppercase text-[#B79A80] mt-1">
              {profile.role} · {profile.location}
            </div>
          </div>

          <nav className="flex flex-wrap justify-center gap-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className="font-body text-xs tracking-wide-2 uppercase text-[#E7D8C6] hover:text-[#C88A63] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="text-center mt-10 font-body text-xs text-[#8A7A6E]">
          © {new Date().getFullYear()} {profile.brand} — Faye. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}
